// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { mergeWithCss } from "@adl/XDL/Utilities/mergeWithCss";
import { orderInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { css } from "styled-components";

orderInformationStyles.orderDetailsGridContainer = {
    ...mergeWithCss(orderInformationStyles.orderDetailsGridContainer, {
        css: css`
            margin-bottom: 20px;
            & > div {
                flex-direction: column;
            }
        `,
    }),
};

orderInformationStyles.orderInformationGridItems = {
    ...mergeWithCss(orderInformationStyles.orderInformationGridItems, {
        css: css`
            padding: 0 15px;
            margin-bottom: 4px;
        `,
    }),
};

orderInformationStyles.orderNumberHeading = {
    ...mergeWithCss(orderInformationStyles.orderNumberHeading, {
        css: css`
            margin-bottom: 20px;
        `,
    }),
};

orderInformationStyles.headingAndTextStyles = {
    heading: {
        variant: "h6",
        as: "h2",
        css: css`
            font-weight: bold;
            font-size: 15px;
            margin-right: 8px;
            line-height: 26px;
            white-space: nowrap;
            margin-bottom: 0;
            @media print {
                font-size: 12px;
            }
        `,
    },
    text: {
        css: css`
            font-size: 15px;
            line-height: 26px;
        `,
    },
};
